import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_AddInputParam, Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const HTTPModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.httpRequest,
  templateType: ModuleTemplateTypeEnum.tools,
  flowType: FlowNodeTypeEnum.httpRequest,
  avatar: '/imgs/module/http.png',
  name: 'HTTP 请求',
  description: '可以发出一个 HTTP 请求，实现更为复杂的操作（联网搜索、数据库查询等）',
  isTool: true,
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.httpMethod,
      type: FlowNodeInputTypeEnum.custom,
      value: 'GET',
      valueType: ModuleIOValueTypeEnum.string,
      label: '请求方式',
      description: '要使用的请求方式',
      required: true,
      showTargetInApp: false,
      showTargetInPlugin: false,
      list: [
        { label: 'GET', value: 'GET' },
        { label: 'POST', value: 'POST' },
        { label: 'PUT', value: 'PUT' },
        { label: 'PATCH', value: 'PATCH' },
        { label: 'DELETE', value: 'DELETE' },
      ],
    },
    {
      key: ModuleInputKeyEnum.httpReqUrl,
      type: FlowNodeInputTypeEnum.hidden,
      valueType: ModuleIOValueTypeEnum.string,
      label: '请求地址',
      description: '要请求的地址',
      placeholder: 'https://api.ai.com/getInventory',
      required: true,
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      key: ModuleInputKeyEnum.httpHeaders,
      type: FlowNodeInputTypeEnum.custom,
      valueType: ModuleIOValueTypeEnum.map,
      value: [],
      label: '请求参数',
      description: '请求的参数',
      required: false,
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      key: ModuleInputKeyEnum.httpParams,
      type: FlowNodeInputTypeEnum.hidden,
      valueType: ModuleIOValueTypeEnum.map,
      value: [],
      label: '',
      required: false,
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      key: ModuleInputKeyEnum.httpBody,
      type: FlowNodeInputTypeEnum.hidden,
      valueType: ModuleIOValueTypeEnum.map,
      value: '',
      label: '',
      required: false,
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      ...Input_Template_AddInputParam,
      editField: {
        key: true,
        description: true,
        dataType: true,
      },
      defaultEditFieldValue: {
        label: '',
        key: '',
        description: '',
        valueType: ModuleIOValueTypeEnum.string,
      },
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.httpRawResponse,
      label: '原始响应',
      description: 'HTTP请求的原始响应。只能接受字符串或JSON类型响应数据。',
      valueType: ModuleIOValueTypeEnum.any,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.httpOkResponse,
      label: '请求成功',
      description: '请求状态为200时触发',
      valueType: ModuleIOValueTypeEnum.boolean,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.httpFailedResponse,
      label: '请求失败',
      description: '请求状态不为200时触发',
      valueType: ModuleIOValueTypeEnum.boolean,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
  ],
};
